<template>
  <div id="communication-records">
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="3"
                    style="display:flex;align-items: center;">
            <ipub-radio :checked="params.operated"
                        @change="params.operated=!params.operated;getList()"
                        checkBox>
              <font class="nowrap">Action Email</font>
            </ipub-radio>
            <ipub-radio :checked="params.toed	"
                        @change="params.toed	=!params.toed;getList()"
                        checkBox
                        label="To" />
            <ipub-radio :checked="params.cced"
                        @change="params.cced=!params.cced;getList()"
                        checkBox
                        label="CC" />
            <ipub-radio :checked="params.bcced"
                        @change="params.bcced=!params.bcced;getList()"
                        checkBox
                        label="BCC" />
          </ipub-col>
          <ipub-col :span="4.5">
            <ipub-input v-model.trim="subject"
                        placeholder="Search for title" />
          </ipub-col>
          <ipub-col :span="4.5">
            <site-search-group v-model.trim="params.email"
                               placeholder="Search for email"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="12">
            <ipub-col :span="6"
                      class="flex">
              <span class="ipub-p2 fw-bd line-h-40"
                    style="min-width:120px">Operation Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:500px"
                                      :placeholder="['From','To']"
                                      @change="handleDateChange"
                                      v-model="date" />
            </ipub-col>
            <ipub-col :span="6"
                      class="flex">
              <span class="ipub-p2 fw-bd line-h-40">Status</span>
              <ipub-select v-model="params.status"
                           @change="getList()"
                           class="mar-l-12"
                           :clear="true"
                           placeholder="Select Status">
                <ipub-select-option v-for="(item,key) in statusList"
                                    :key="'editorList'+key"
                                    :value="key">
                  {{item}}
                </ipub-select-option>
              </ipub-select>
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div class="records-table">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:templateList="{text}">
          <div v-if="text && text.length">
            <div v-for="item in text"
                 class="ipub-cursor-pointer"
                 :key="item.id"
                 @click="download(item)">
              {{item.name}}
            </div>
          </div>
          <div v-else>--</div>
        </template>
        <template v-slot:emails="{text}">
          <ipub-tooltip style="width:100%"
                        v-if="text"
                        omis="omis"
                        :label="text.split(',').join(', ')"
                        placement="bottomLeft">
            {{text}}
          </ipub-tooltip>
          <template v-else>- -</template>
        </template>
        <template v-slot:status="{text}">
          <div>
            <ipub-label cover
                        v-if="text === 'DELIVERED'"
                        style="width:80px"
                        type="success"
                        size="small">{{statusList[text]}}</ipub-label>
            <ipub-label cover
                        v-else-if="text === 'FAILED'"
                        style="width:80px"
                        type="danger"
                        size="small">{{statusList[text]}}</ipub-label>
            <ipub-label cover
                        v-else
                        style="width:80px"
                        type="default"
                        size="small">{{statusList[text]}}</ipub-label>
          </div>
        </template>
        <template v-slot:time="{text}">
          <span v-if="text">{{ text?$moment(text).format('HH:mm:ss  DD / MM / YYYY'): '- -' }}</span>
        </template>
        <template v-slot:operator="{record}">
          <div class="omis">{{record.operator && record.operator.email}}</div>
        </template>
        <template v-slot:actions="{record}">
          <ipub-tooltip placement="bottomRight">
            <div slot="title">Details</div>
            <ipub-icon type="iconViewDetails"
                       @click="detail(record)" />

          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <detailDialog @cancel="cancel"
                  :isVisable="isVisable"
                  :id="id"></detailDialog>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
